export const API_SCHEDULE_ORDER_NOTI = 'pl-ts/api/plg/v1/seller/order/noti-schedule'
export const API_SCHEDULE_ORDER_PUSH_NOTI = 'pl-ts/api/plg/v1/seller/order/push-noti-schedule'
export const API_EXPORT_PRE_ORDER = 'pl-ts/api/plg/v1/seller/order/export'
